import 'Styles/post.scss';

import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import isEqual from 'lodash/isEqual';

import threadViewSelector from 'Selectors/threadViewSelector';

import AdComponent from 'Components/ads/AdComponent';
import InThreadAdComponent from 'Components/ads/inThreadAdComponent';
import Post from 'Components/posts/PostComponent';
import LoaderCss from 'Components/common/LoaderCssComponent';

import { resetThread } from 'Actions/ThreadviewActions';
import { resetSelectedItem } from 'Actions/MetaActions';
import PhotoSwipe from 'Components/common/PhotoSwipe';
import { resetGallery } from 'Actions/PhotoGalleryActions';
import { getPageSize } from 'Actions/UserSettingsActions';

import { pathToPost } from 'Utils/nav/NavHelpers';

class PostListComponent extends React.Component {
	constructor( props ) {
		super( props );
		this.pages = {};
	}

	componentDidMount() {
		this.props.dispatch( resetSelectedItem() );
		window.addEventListener( 'popstate', this._resetThread );
		window.addEventListener( 'popstate', this._resetGallery );
	}

	componentWillUnmount(){
		window.removeEventListener( 'popstate', this._resetThread );
		window.removeEventListener( 'popstate', this._resetGallery );
		this.props.dispatch( resetSelectedItem() );
	}

	shouldComponentUpdate( nextProps ) {
		return (
			!isEqual( nextProps.meta.selectedElements, this.props.meta.selectedElements ) ||
			!isEqual( nextProps.threadview, this.props.threadview ) ||
			!isEqual( nextProps.pages, this.props.pages )
		);
	}

	_resetThread = () => {
		if( !/topics|search/.test( location.hash ) ) {
			this.props.dispatch( resetSelectedItem() );
			this.props.dispatch( resetThread() );
		}
	};

	_resetGallery = () => {
		if( !/topics|search/.test( location.hash ) ) {
			this.props.dispatch( resetGallery() );
		}
	};

	gotoPost(id) {
		this.props.dispatch( push( pathToPost(id) ) );
	}

	getThreadTitle( topicId ) {
		if( topicId && this.props.isUserProfile ) {
			let topic = this.props.threadview.entities.topics[ parseInt( topicId) ];
			return topic.title;
		}
		return '';
	}

	buildPost = ( post, i, pageNum, pageSize ) => {
		const {entities: {posts, users}, page, total, totalPages } = this.props.threadview,
			{ ustate } = this.props;

		let isSearch = this.props.isSearch,
			isUserProfile = this.props.isUserProfile,
			isFirst = ( i === 0 && pageNum === 1 ) , // Let's assume we want the first ad on the first page
			isLast = page === totalPages && post.num === total;

		let adUnit = null, inThreadAd = null;

		let postNum = post.num || 1 + i + ( (pageNum - 1) * pageSize );

		switch( true ) {
			case isUserProfile:
			// no Ads on user profile
				break;

			case isSearch:
				let searchProp = {
					isTop: false,
					page: ( ( this.props.threadview.page - 1 ) * ( pageSize / 10 ) ) + ( ( i + 1 ) / 10 ),
					searchQuery: this.props.threadview.query.searchQuery
				};
				adUnit = ( ( i + 1 ) % 10 === 0 ) ? <AdComponent key={ `In_Search_Ad_${ post.id }` } adType="0" adName={ 'In_Search_Ad_' + post.id } search={ searchProp } tag="li" /> : null;
				break;

			default:
				let k = i + 1,
					adType = isFirst ? 5 : 1,
					fallbackAdType = adType === 5 ? [ 1 ] : [];

				// On first page after the 3th post
				inThreadAd = ( k === 3 && pageNum === 1 ) ?
					<InThreadAdComponent key={ `taboola_inthread_${ post.id }` } adContainerId="taboola-mid-article-stream-thumbnails" className="" /> : null;

				switch( true ) {
					case ( k === 4 && pageNum === 1 ):
						// after 4th and fallback to regular 320x50 - 'inContentTopicAd_2' - yieldmo Hyperscroll/Outstream
						adUnit = <AdComponent key={ `In_Content_Ad_2_${ post.id }` } adType="205" fallbackAdType={ [ 1 ] } adName={ 'In_Content_Ad_2_' + post.id } tag="li"/>;
						break;

					case ( k % 8 === 0 && !isLast ):
						// Every 8 posts unless is the last thing in the page
						adUnit = <AdComponent key={ `In_Content_Ad_1_${ post.id }` } adType="105" fallbackAdType={ [ 1 ] } adName={ 'In_Content_Ad_1_' + post.id } tag="li"/>;
						break;

					case ( ( k % 4 === 0 || ( i === 0 && isFirst ) ) && !isLast ):
						// Every 4 posts unless we have already one, skip the top position on first page and last position in last page
						adUnit = <AdComponent key={ `In_Content_Ad_${ post.id }` } adType={ adType } fallbackAdType={ fallbackAdType } adName={ 'In_Content_Ad_' + post.id } tag="li"/>;
						break;

					default:
						adUnit = null;
				}
		}

		let renderedPost = [
			<li key={ `post_${post.id}` } id={ `post_container_${ post.id }` } className="post_container"
				onClick={ () => ( isSearch || isUserProfile ? this.gotoPost( post.id ) : true ) } >
				<Post
					isSearch={ isSearch }
					isUserProfile={ isUserProfile }
					postId={ post.id }
					postNum={ postNum }
					posts={ posts }
					users={ users }
					perms={ ustate.perms }
					key={ post.id }
					allowHtml={ !!( this.props.threadview.allowhtml ) }
					threadTitle={ this.getThreadTitle( post.topic ) }
				/>
			</li>
		];

		if( inThreadAd ) {
			renderedPost.push( inThreadAd );
		}
		if( adUnit ) {
			renderedPost.push( adUnit );
		}

		return renderedPost;
	};

	buildPage = ( pageNum, pageSize ) => {
		const { entities, result } = this.props.threadview;

		let post = result.posts.filter( e => entities.posts[ e ] && entities.posts[ e ].page === pageNum ),
			postList = post.map( ( id, i ) => this.buildPost( entities.posts[ id ], i, pageNum, pageSize ) );

		return (
			<ul key={pageNum} className={`scroll_page post_page page_${pageNum}`}>
				{ postList }
			</ul>
		)
	};

	render() {
		const pageSize = this.props.dispatch( getPageSize() );
		let postsListPage = this.props.pages.map( ( pageNum ) => this.buildPage( pageNum, pageSize ) );

		if( !this.props.threadview.loaded ) {
			return <LoaderCss key="loader" />;
		}

		return (
			<div ref={ this.props.listRef } className="posts">
				{ postsListPage }
				<PhotoSwipe />
			</div>
		);
	}
}

PostListComponent.propTypes = {
	threadview: PropTypes.object.isRequired,
	dispatch: PropTypes.func.isRequired,
	pages: PropTypes.array.isRequired,
};

PostListComponent.defaultProps = {
	isSearch: false,
	isUserProfile: false
};

export default connect( threadViewSelector )( PostListComponent );



// WEBPACK FOOTER //
// ./src/components/posts/PostListComponent.js